import { gql } from '@apollo/client';

export const GET_PUBLIC_FORM = gql`
  query GetPublicForm($formId: String!) {
    orgName
    orgLogo
    vm {
      form(formId: $formId) {
        formId
        title
        description
        successMessage
        redirectUrl
        closedMessage
        dateClosed
        isPubliclyAccessible
        allowMultipleSubmissions
        hasCurrentUserSubmitted
        formItems {
          __typename
          ... on VOLUNTEER_FormItemFieldType {
            formItemId
            order
            optional
            triggerItem {
              formTriggerItemId
              order
              trigger {
                ... on VOLUNTEER_DynamicDropdownFieldFormTriggerType {
                  triggerOption {
                    dropdownFieldOptionId
                  }
                }
                ... on VOLUNTEER_DynamicCheckboxFieldFormTriggerType {
                  triggerOption {
                    checkboxFieldOptionId
                  }
                }
                ... on VOLUNTEER_DynamicMultipleChoiceFieldFormTriggerType {
                  triggerOption {
                    multipleChoiceFieldOptionId
                  }
                }
                ... on VOLUNTEER_DynamicQuizFieldFormTriggerType {
                  triggerOption {
                    quizTaskFieldOptionId
                  }
                }
              }
            }
            field {
              __typename
              taskFieldId
              name
              description
              ... on VOLUNTEER_ShortTextTaskFieldType {
                taskFieldId
                name
                description
              }
              ... on VOLUNTEER_LongTextTaskFieldType {
                taskFieldId
                name
                description
              }
              ... on VOLUNTEER_NumberTaskFieldType {
                taskFieldId
                name
                description
              }
              ... on VOLUNTEER_EmailTaskFieldType {
                taskFieldId
                name
                description
              }
              ... on VOLUNTEER_PhoneTaskFieldType {
                taskFieldId
                name
                description
              }
              ... on VOLUNTEER_DateTaskFieldType {
                taskFieldId
                name
                description
              }
              ... on VOLUNTEER_AddressTaskFieldType {
                taskFieldId
                name
                description
              }
              ... on VOLUNTEER_AttachmentTaskFieldType {
                taskFieldId
                name
                description
              }
              ... on VOLUNTEER_SignatureTaskFieldType {
                taskFieldId
                name
                description
              }
              ... on VOLUNTEER_RatingTaskFieldType {
                taskFieldId
                name
                description
              }
              ... on VOLUNTEER_FormMultipleChoiceTaskFieldType {
                taskFieldId
                name
                description
                dynamic
                multipleChoiceOptions {
                  multipleChoiceFieldOptionId
                  name
                  order
                  allowText
                  trigger {
                    items {
                      item {
                        __typename
                        ... on VOLUNTEER_FormItemFieldType {
                          formItemId
                          order
                          optional
                          field {
                            __typename
                            taskFieldId
                            name
                            description
                          }
                        }
                        ... on VOLUNTEER_FormItemHeadingType {
                          formItemId
                          order
                          heading
                        }
                        ... on VOLUNTEER_FormItemContentType {
                          formItemId
                          order
                          content
                        }
                        ... on VOLUNTEER_FormItemMediaType {
                          formItemId
                          order
                        }
                      }
                      order
                    }
                  }
                }
              }
              ... on VOLUNTEER_FormCheckboxTaskFieldType {
                taskFieldId
                name
                description
                dynamic
                checkboxOptions {
                  checkboxFieldOptionId
                  name
                  order
                  allowText
                  trigger {
                    items {
                      item {
                        __typename
                        ... on VOLUNTEER_FormItemFieldType {
                          formItemId
                          order
                          optional
                          field {
                            __typename
                            taskFieldId
                            name
                            description
                          }
                        }
                        ... on VOLUNTEER_FormItemHeadingType {
                          formItemId
                          order
                          heading
                        }
                        ... on VOLUNTEER_FormItemContentType {
                          formItemId
                          order
                          content
                        }
                        ... on VOLUNTEER_FormItemMediaType {
                          formItemId
                          order
                        }
                      }
                      order
                    }
                  }
                }
              }
              ... on VOLUNTEER_FormDropdownTaskFieldType {
                taskFieldId
                name
                description
                dynamic
                freeSolo
                dropdownOptions {
                  dropdownFieldOptionId
                  name
                  order
                  allowText
                  trigger {
                    items {
                      item {
                        __typename
                        ... on VOLUNTEER_FormItemFieldType {
                          formItemId
                          order
                          optional
                          field {
                            __typename
                            taskFieldId
                            name
                            description
                          }
                        }
                        ... on VOLUNTEER_FormItemHeadingType {
                          formItemId
                          order
                          heading
                        }
                        ... on VOLUNTEER_FormItemContentType {
                          formItemId
                          order
                          content
                        }
                        ... on VOLUNTEER_FormItemMediaType {
                          formItemId
                          order
                        }
                      }
                      order
                    }
                  }
                }
              }
              ... on VOLUNTEER_FormQuizTaskFieldType {
                taskFieldId
                name
                description
                dynamic
                allowRetry
                quizTaskFieldOptions {
                  quizTaskFieldOptionId
                  name
                  order
                  allowText
                  trigger {
                    items {
                      item {
                        __typename
                        ... on VOLUNTEER_FormItemFieldType {
                          formItemId
                          order
                          optional
                          field {
                            __typename
                            taskFieldId
                            name
                            description
                          }
                        }
                        ... on VOLUNTEER_FormItemHeadingType {
                          formItemId
                          order
                          heading
                        }
                        ... on VOLUNTEER_FormItemContentType {
                          formItemId
                          order
                          content
                        }
                        ... on VOLUNTEER_FormItemMediaType {
                          formItemId
                          order
                        }
                      }
                      order
                    }
                  }
                }
                quizTaskFieldCorrect {
                  quizTaskFieldCorrectId
                  correctText
                  quizTaskFieldOption {
                    quizTaskFieldOptionId
                  }
                }
              }
              ... on VOLUNTEER_FormMatrixTaskFieldType {
                taskFieldId
                name
                description
                rows {
                  matrixRowId
                  name
                  order
                }
                columns {
                  matrixColumnId
                  name
                  order
                }
              }
              ... on VOLUNTEER_TimeTaskFieldType {
                taskFieldId
                name
                description
              }
              ... on VOLUNTEER_UrlTaskFieldType {
                taskFieldId
                name
                description
              }
              ... on VOLUNTEER_YesNoTaskFieldType {
                taskFieldId
                name
                description
              }
              ... on VOLUNTEER_LinearScaleTaskFieldType {
                taskFieldId
                name
                description
                minValue
                maxValue
                minLabel
                maxLabel
              }
              ... on VOLUNTEER_NpsTaskFieldType {
                taskFieldId
                name
                description
              }
            }
          }
          ... on VOLUNTEER_FormItemHeadingType {
            formItemId
            order
            heading
            triggerItem {
              formTriggerItemId
              order
              trigger {
                ... on VOLUNTEER_DynamicDropdownFieldFormTriggerType {
                  triggerOption {
                    dropdownFieldOptionId
                  }
                }
                ... on VOLUNTEER_DynamicCheckboxFieldFormTriggerType {
                  triggerOption {
                    checkboxFieldOptionId
                  }
                }
                ... on VOLUNTEER_DynamicMultipleChoiceFieldFormTriggerType {
                  triggerOption {
                    multipleChoiceFieldOptionId
                  }
                }
                ... on VOLUNTEER_DynamicQuizFieldFormTriggerType {
                  triggerOption {
                    quizTaskFieldOptionId
                  }
                }
              }
            }
          }
          ... on VOLUNTEER_FormItemContentType {
            formItemId
            order
            content
            triggerItem {
              formTriggerItemId
              order
              trigger {
                ... on VOLUNTEER_DynamicDropdownFieldFormTriggerType {
                  triggerOption {
                    dropdownFieldOptionId
                  }
                }
                ... on VOLUNTEER_DynamicCheckboxFieldFormTriggerType {
                  triggerOption {
                    checkboxFieldOptionId
                  }
                }
                ... on VOLUNTEER_DynamicMultipleChoiceFieldFormTriggerType {
                  triggerOption {
                    multipleChoiceFieldOptionId
                  }
                }
                ... on VOLUNTEER_DynamicQuizFieldFormTriggerType {
                  triggerOption {
                    quizTaskFieldOptionId
                  }
                }
              }
            }
          }
          ... on VOLUNTEER_FormItemMediaType {
            formItemId
            order
            triggerItem {
              formTriggerItemId
              order
              trigger {
                ... on VOLUNTEER_DynamicDropdownFieldFormTriggerType {
                  triggerOption {
                    dropdownFieldOptionId
                  }
                }
                ... on VOLUNTEER_DynamicCheckboxFieldFormTriggerType {
                  triggerOption {
                    checkboxFieldOptionId
                  }
                }
                ... on VOLUNTEER_DynamicMultipleChoiceFieldFormTriggerType {
                  triggerOption {
                    multipleChoiceFieldOptionId
                  }
                }
                ... on VOLUNTEER_DynamicQuizFieldFormTriggerType {
                  triggerOption {
                    quizTaskFieldOptionId
                  }
                }
              }
            }
            media {
              taskMediaId
              name
              description
              ... on VOLUNTEER_YoutubeMediaType {
                videoId
              }
              ... on VOLUNTEER_VimeoMediaType {
                videoId
              }
            }
          }
          ... on VOLUNTEER_FormItemRepeatableGroupType {
            formItemId
            order
            title
            description
            label
            minInstances
            maxInstances
            groupItems {
              __typename
              ... on VOLUNTEER_FormItemFieldType {
                formItemId
                order
                optional
                field {
                  __typename
                  taskFieldId
                  name
                  description
                  ... on VOLUNTEER_ShortTextTaskFieldType {
                    taskFieldId
                    name
                    description
                  }
                  ... on VOLUNTEER_LongTextTaskFieldType {
                    taskFieldId
                    name
                    description
                  }
                  ... on VOLUNTEER_NumberTaskFieldType {
                    taskFieldId
                    name
                    description
                  }
                  ... on VOLUNTEER_EmailTaskFieldType {
                    taskFieldId
                    name
                    description
                  }
                  ... on VOLUNTEER_PhoneTaskFieldType {
                    taskFieldId
                    name
                    description
                  }
                  ... on VOLUNTEER_DateTaskFieldType {
                    taskFieldId
                    name
                    description
                  }
                  ... on VOLUNTEER_AddressTaskFieldType {
                    taskFieldId
                    name
                    description
                  }
                  ... on VOLUNTEER_AttachmentTaskFieldType {
                    taskFieldId
                    name
                    description
                  }
                  ... on VOLUNTEER_SignatureTaskFieldType {
                    taskFieldId
                    name
                    description
                  }
                  ... on VOLUNTEER_RatingTaskFieldType {
                    taskFieldId
                    name
                    description
                  }
                  ... on VOLUNTEER_FormMultipleChoiceTaskFieldType {
                    taskFieldId
                    name
                    description
                    dynamic
                    multipleChoiceOptions {
                      multipleChoiceFieldOptionId
                      name
                      order
                      allowText
                    }
                  }
                  ... on VOLUNTEER_FormCheckboxTaskFieldType {
                    taskFieldId
                    name
                    description
                    dynamic
                    checkboxOptions {
                      checkboxFieldOptionId
                      name
                      order
                      allowText
                    }
                  }
                  ... on VOLUNTEER_FormDropdownTaskFieldType {
                    taskFieldId
                    name
                    description
                    dynamic
                    freeSolo
                    dropdownOptions {
                      dropdownFieldOptionId
                      name
                      order
                      allowText
                    }
                  }
                  ... on VOLUNTEER_FormQuizTaskFieldType {
                    taskFieldId
                    name
                    description
                    dynamic
                    allowRetry
                    quizTaskFieldOptions {
                      quizTaskFieldOptionId
                      name
                      order
                      allowText
                    }
                    quizTaskFieldCorrect {
                      quizTaskFieldCorrectId
                      correctText
                      quizTaskFieldOption {
                        quizTaskFieldOptionId
                      }
                    }
                  }
                  ... on VOLUNTEER_FormMatrixTaskFieldType {
                    taskFieldId
                    name
                    description
                    rows {
                      matrixRowId
                      name
                      order
                    }
                    columns {
                      matrixColumnId
                      name
                      order
                    }
                  }
                  ... on VOLUNTEER_TimeTaskFieldType {
                    taskFieldId
                    name
                    description
                  }
                  ... on VOLUNTEER_UrlTaskFieldType {
                    taskFieldId
                    name
                    description
                  }
                  ... on VOLUNTEER_YesNoTaskFieldType {
                    taskFieldId
                    name
                    description
                  }
                  ... on VOLUNTEER_LinearScaleTaskFieldType {
                    taskFieldId
                    name
                    description
                    minValue
                    maxValue
                    minLabel
                    maxLabel
                  }
                  ... on VOLUNTEER_NpsTaskFieldType {
                    taskFieldId
                    name
                    description
                  }
                }
              }
              ... on VOLUNTEER_FormItemHeadingType {
                formItemId
                order
                heading
              }
              ... on VOLUNTEER_FormItemContentType {
                formItemId
                order
                content
              }
            }
          }
        }
      }
    }
  }
`;
